<template>
	<div class="planList">
		<div class="planTitle">
			<span class="title-left">猜你喜欢</span>
			<div class="title-right" @click="appListJump(lotid)">
				<span class="static">全部</span>
				<span class="iconfont">&#xe615;</span>
			</div>
		</div>
		<div class="planCont">
			<div class="domli" v-for="item in InfoList" :key="item" @click="appDetail(item.lyClassCode,item.erAgintOrderId,from,myUni)">
				<div class="fajian">
					<div class="cpan">
						<span class="zjxq-photo">
							<img :src="item.headPortrait">
						</span>
						<div class="rwjs">
							<span>
								{{item.expertsNickName}}
								<i class="kongxin" v-if="item.label1">{{item.label1}}</i>
								<i class="kongxin" v-if="item.label2">{{item.label2}}</i>
							</span>
							<span class="fensiNum">{{item.expertDes}}</span>
						</div>
						<div class="mingzl" v-if="item.hitRate&&item.hitRate!==0">
							<span class="hitnum">{{item.hitRate}}</span>
							<span class="hitfuhao">%</span>
							<span class="hititle">命中率</span>
						</div>
					</div>
				</div>
				<div class="fabs">
					<p class="tjbt">{{item.title}}</p>
				</div>
				<template v-if="newCodeId=='205'||newCodeId=='1002'">
					<div class="match"  v-for="value in item.matchList" :key="value">
						<span class="icons">{{item.orderType}}</span>
						<span class="times">{{value.matchDateTime}}</span>
						<span class="leagname">{{value.leagueName}}</span>
						<span class="leagteam">{{`${value.homeName} vs ${value.awayName}`}}</span>
					</div>
				</template>
				
				<div class="matchszc" v-if="newCodeId=='001'||newCodeId=='002'||newCodeId=='113'||newCodeId=='108'">
					<div class="matchszc-left">
						<span class="icons">{{item.orderType}}</span>
						<span class="times">{{item.issue}}期</span>
					</div>
					<span class="leagteam">截止时间 {{item.closeTime}}</span>
				</div>
				<div class="info">
					<span class="fabutime">{{item.dateBefore}}</span>
					<div class="rightdiv">
						<span class="qiubi">{{item.prize}}球币</span>
						<span class="tuihui">{{item.firstOrderDes}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import { ref,reactive,getCurrentInstance,inject } from 'vue'
	import * as uni  from '@/assets/js/uni.webview.1.5.4.js'
	export default{
		//开奖列表返回彩种号对应获取推荐方案传递参数彩种号
		//双色球：001  ---  001
		//大乐透：113  ---  113
		//福彩3D:002  ---  002
		//排列三：108  ---  108
		//排列五：109  ---  无
		//七星彩：110  ---  无
		//七乐彩：003  ---  无
		//胜负任九：300  ---  205
		//竞彩足球：201  ---  202
		//竞彩篮球：200  ---  204
		//北京单场：400  ---  208
		//半全场：302  ---  无
		//进球彩：303  ---  无
		
		//专家方案展示规则
		//1）双色球、大乐透、福彩3D，展示对应彩种的方案；
		//2）排列三、排列五，展示排列三方案；
		//3）胜负任九，展示任九方案；若无任九方案，展示推荐方案列表方案
		//4）半全场、进球彩：展示推荐列表方案；
		//5) 七星彩、七乐彩：星期一三五六展示【大乐透】方案、二四日展示【双色球】方案
		
		name:'Tuijian',
		
		setup (props,context) {
			const baseurl = getCurrentInstance().appContext.config.globalProperties.axiosurl
			const { lotid } = inject('lottery')
			const from = inject('from')
			let InfoList = ref([])
			let newCodeId = ref('')
			let newclassId = ref('000')
			const day = new Date().getDay()
			if(lotid=="001"||lotid=="113"||lotid=="002"){
				newCodeId.value = lotid
			}else if(lotid=="108"||lotid=="109"){
				newCodeId.value = '108'
			}else if(lotid=="300"){
				newCodeId.value = '205'
			}else if(lotid=="110"||lotid=="003"){
				if(day==1||day==3||day==5||day==6){
					newCodeId.value = '113'
				}else{
					newCodeId.value = '001'
				}
			}else if(lotid=="302"||lotid=="303"){
				newCodeId.value = '1002'
				newclassId.value = '001'
			}
			const appListJump = (lot)=>{
				if(this.from!=='baidu'){
					switch(lot){
						case '001':
							window.location.href = `/module/zcwh5/expert/szcRecommend.jsp?lcode=${lot}`
						break
						case '113':
							window.location.href = `/module/zcwh5/expert/szcRecommend.jsp?lcode=${lot}`
						break
						case '002':
							window.location.href = `/module/zcwh5/expert/szcRecommend.jsp?lcode=${lot}`
						break
						case '108':
							window.location.href = `/module/zcwh5/expert/szcRecommend.jsp?lcode=${lot}`
						break
						case '109':
							window.location.href = `/module/zcwh5/expert/szcRecommend.jsp?lcode=${lot}`
						break
						case '110':
							window.location.href = `/module/zcwh5/expert/crazy.jsp`
						break
						case '003':
							window.location.href = `/module/zcwh5/expert/crazy.jsp`
						break
						case '300':
							window.location.href = `/module/zcwh5/expert/crazy.jsp`
						break
						case '201':
							window.location.href = `/module/zcwh5/expert/footBall.jsp`
						break
						case '200':
							window.location.href = `/module/zcwh5/expert/basketBall.jsp`
						break
						default:
							window.location.href = `/module/zcwh5/expert/crazy.jsp`
						break
					}
				}
			}
			const appDetail = (lotclass,order,from,myUni)=>{
				if(from==='baidu'){
					console.log(myUni.webView)
					myUni.webView.navigateTo({
						url:'/pages/planinfo/planinfo?planid='+order
					});
				}else{
					window.location.href = `/module/zcwh5/expert/plans.jsp?planid=${order}&lotid=${lotclass}`
				}
				
			}
			const useTjlist = async (lotteryClassCode,classCode)=>{
				let accessData = {
					"serviceName":"zjtjIndexService",
					"methodName":"getExpertsPlanListNew",
					"parameters":{
						"pageSize": "20",
						"curPage": "1",
						"classCode": classCode,//--彩种分类：000、全部；001、竞彩；002、数字彩
						"lyClassCode": lotteryClassCode //类别：1001：关注列表；1002：推荐；1003：高命中；1004：高回报；1005：不中退；1006：免费；1007：VIP
					}
				}
				accessData = JSON.stringify(accessData)
				const {data:{result:{data:ldata}}} = await axios.post(`${baseurl}/api/zjtj.action?accessSecretData=${accessData}`)
				console.log(ldata)
				if(ldata.length==0){
					//胜负任九，展示任九方案；若无任九方案，展示推荐方案列表方案
					if(lotteryClassCode=="205"){
						useTjlist("1002","001")
					}
				}
				InfoList.value = ldata
			}
			useTjlist(newCodeId.value,newclassId.value)
			return { appListJump,appDetail,InfoList,newCodeId,lotid,from }
		}
	}
</script>

<style scoped="scoped">
	.planList{width:100%;display: flex;flex-direction: column;background:#FFFFFF;}
	.planTitle{width:100%;height:.45rem;padding:.1rem .15rem;box-sizing: border-box;display: flex;flex-direction: row;align-items: center;justify-content: space-between;}
	.title-left{font-size: .18rem;color:#333333;font-weight: bold;}
	.title-right{display:flex;flex-direction: row;align-items: center;}
	.static{font-size:.12rem;color:#777777;margin-right:.03rem;}
	.title-right .iconfont{font-size: .17rem;}
	.planCont{width:100%;}
	.domli{border-bottom: .01rem solid #F4F4F4;background: #fff;position: relative;padding: .2rem;}
	.fajian {margin: 0 0 .1rem 0;padding-top: .1rem;position: relative;}
	.fajian .cpan .zjxq-photo {width: 50px;height: 50px;display: inline-block;margin-bottom: 0;position: relative;float: left;}
	.cpan span img {width: 100%;height: 100%;border-radius: 50%;}
	.rwjs {position: relative;width: auto;float: left;}
	.rwjs span img {width: 15px;height: auto;float: none;border-radius: 50%;}
	.rwjs span i {display: inline-block;font-size: 11px;border-radius: 2px;padding: 0 2px;}
	.kongxin {margin-left: 5px;line-height: 14px;color: rgba(224,63,69,1);border: 1px solid rgba(224,63,69,1);font-weight: normal;}
	 .shixin{color: rgba(255,255,255,1);background: rgba(205,0,9,1);font-size: 11px;line-height: 16px;margin-left: 5px;}
	.rwjs span.fensiNum {color: #999;font-size: 13px;margin-top: 1px;}
	.rwjs span {display: block;margin-left: 5px;height: 24px;font-size: 15px;color: rgba(51,51,51,1);line-height: 24px;font-weight: 600;}
	.fenlei:after, .zjlist:after, .index-bang:after, .saishi-top:after, .ss-bifen:after, .tb-zjxq:after, .fajian:after, .cpan:after, .tj-blcok:after, .tj-blcok ul:after, .tejia-block:after {content: ' ';display: block;width: 100%;height: 0px;clear: both;}
	.fabs {overflow: hidden;}
	.tjbt {font-size: .16rem;color: #333333;display: block;line-height: 21px;margin-top: 5px;margin-left: 0px;font-weight: 500;}
	.mingzl{position: absolute;right:0;top:0;width:.75rem;height:.55rem;}
	.mingzl .hitnum{font-size: .37rem;color: #F13C1B;top: 0;font-weight: bold;width: .7rem;display: inline-block;text-align: right;position: absolute;right: .11rem;}
	.mingzl .hitfuhao{font-size:.09rem;color:#F13C1B;position: absolute;right:0;top:.09rem;}
	.mingzl .hititle{font-size:.1rem;color:#F13C1B;position: absolute;right:.09rem;bottom:0;}
	.match {padding:0 .1rem;background: #F1F1F1;margin-top:.1rem;margin-bottom:.1rem;height:.28rem;display: flex;flex-direction: row;align-items: center;}
	.match span.icons{padding:0 .04rem;box-sizing: border-box;border:1px solid #2E9FFE;color:#2E9FFE;font-size:.1rem;margin-right:.05rem;border-radius: .02rem;transform: scale(0.8);}
	.match span.leagname{flex:1;text-align: center;}
	.match span.leagteam{flex:3;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
	.match span.times,.match span.leagname,.match span.leagteam{font-size:.12rem;color:#666666;}
	.matchszc{padding:0 .1rem;background: #F1F1F1;margin-top:.1rem;margin-bottom:.1rem;height:.28rem;display: flex;flex-direction: row;align-items: center;justify-content: space-between;}
	.matchszc .matchszc-left{display: flex;flex-direction: row;align-items: center;}
	.matchszc .matchszc-left .icons{padding:0 .04rem;box-sizing: border-box;border:1px solid #2E9FFE;color:#2E9FFE;font-size:.1rem;margin-right:.05rem;border-radius: .02rem;transform: scale(0.8);}
	.matchszc .matchszc-left .times{font-size:.12rem;color:#666666;}
	.matchszc .leagteam{font-size:.12rem;color:#666666;}
	.info {width:100%;display: flex;flex-direction: row;align-items: center;justify-content: space-between;}
	.info .fabutime{font-size:.11rem;color:#999999;}
	.info .rightdiv{display: flex;flex-direction: row;align-items: center;}
	.info .rightdiv .qiubi{font-size:.11rem;color:#F13C1B;margin-right:.05rem;}
	.info .rightdiv .tuihui{font-size:.11rem;color:#957160;}
</style>
